<template>
    <div>
        <div class="badge text-white" :class="variant">
            {{ status }}
        </div>
        <i :class="getClass" class="pl-2" style="font-size: 1.15rem" aria-hidden="true"></i>
    </div>
</template>

<script>
import Vue from 'vue'
import { statusVariant, statusStr } from '@/constants/ticketStatus'
export default Vue.extend({
    props: {
        row: {
            required: true,
        },
        index: {
            required: true,
        },
        datatable: {
            required: true,
        }
    },
    computed: {
        status() {
            return statusStr.get(this.row.status)
        },
        variant() {
            return 'badge-'+statusVariant(this.row.status)
        },
        getClass() {
            if (this.row.priority === 0)
                return 'text-success fa fa-chevron-down';
            if (this.row.priority === 1)
                return 'text-warning fa fa-minus';

            return 'text-danger fa fa-chevron-up';
        }
    }
})
</script>

<style>

</style>